// extracted by mini-css-extract-plugin
export var container = "style-module--container--e244e";
export var detail = "style-module--detail--6aee7";
export var heading = "style-module--heading--09f47";